module.exports = __webpack_public_path__ + "app-static/img/xbd.ca4141bf.png";